import { createFileRoute } from '@tanstack/react-router'
import SigningSettings from '@/pages/settings/signing'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/signing'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <SigningSettings />
}
